export default () => ({
	otpDescription: {
		display: 'flex',
		alignItems: 'start',
		paddingLeft: 20,
	},
	otpWrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});
